module.exports = __webpack_public_path__ + "static/media/neuter.67875f99.svg";